import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const AddScoreModal = ({ show, onHide, onSubmit, categories }) => {
    const [formData, setFormData] = useState({
        category: '',
        name: '',
        score: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = () => {
        onSubmit(formData);
        setFormData({ category: '', name: '', score: '' });
        onHide();
    };

    const handleClose = () => {
        setFormData({ category: '', name: '', score: '' });
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Add Season High Score</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>Category</Form.Label>
                        <Form.Select name="category" onChange={handleChange} value={formData.category}>
                            <option value="">Select Category</option>
                            {categories.map((cat, idx) => (
                                <option key={idx} value={cat.key}>{cat.label}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mt-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control type="text" name="name" value={formData.name} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mt-3">
                        <Form.Label>Score</Form.Label>
                        <Form.Control type="number" name="score" value={formData.score} onChange={handleChange} />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Close</Button>
                <Button variant="primary" onClick={handleSubmit}>Add Score</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddScoreModal;
